import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** Merge Tailwind classes with conditional logic. The canonical shadcn helper. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Normalizes text for search comparisons: folds curly/smart quotes to
 * straight ones, strips zero-width characters (common artifacts of
 * copy-pasting a patient name from a chart, PDF, or Word doc), and
 * lowercases. Without this, a nickname like `John "Jacob" Jingleheimerschmidt`
 * can silently fail to match a search for "Jacob" if the quotes around it
 * are curly rather than straight, or carry an invisible character.
 */
export function normalizeForSearch(text: string): string {
  return text
    .normalize("NFKC")
    .replace(/[\u2018\u2019\u201A\u201B\u2032\u2035]/g, "'")
    .replace(/[\u201C\u201D\u201E\u201F\u2033\u2036]/g, '"')
    .replace(/[\u200B-\u200D\uFEFF]/g, "")
    .toLowerCase();
}

/** Substring search helper that uses {@link normalizeForSearch} on both sides. */
export function matchesSearch(name: string, query: string): boolean {
  return normalizeForSearch(name).includes(normalizeForSearch(query));
}
